import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid } from '@material-ui/core';
import { blackColor } from '../../../assets/jss/nextjs-material-kit-pro';

const styles = makeStyles((theme) => ({
  frame: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  centerTable: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  leftSide: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '40%',
      margin: '0 45px 0 45px',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      margin: '0 5px 0 5px',
    },
  },
  rightSide: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '40%',
      margin: '0 45px 0 45px',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      margin: '0 5px 0 5px',
    },
  },
  bold: {
    fontWeight: 600,
  },
  title: {
    fontSize: '1.10rem',
    lineHeight: '1.65rem',
    fontWeight: 700,
    textAlign: 'left',
    margin: '5px 0',
    [theme.breakpoints.up('md')]: {
      padding: '10px 0 15px 0',
    },
    [theme.breakpoints.down('md')]: {
      padding: '5px 0 10px 0',
    },
  },
  description: {
    fontSize: '1.00rem',
    fontWeight: 500,
    textAlign: 'left',
    padding: '5px 0 15px 0',
    color: blackColor,
  },
  link: {
    color: blackColor,
    textDecoration: 'underline',
    fontSize: '1rem',
    fontWeight: 600,
  },
  spacer: {
    padding: '8px 0',
  },
  divider: {
    borderBottom: '2px solid #dcdcdc',
  },
}));

export default function AlumniLinks(props) {
  const classes = styles();

  return (
    <Box className={classes.frame}>
      <Grid container spacing={3} direction="row" className={classes.centerTable}>
        <Grid item xs={12} lg={6} className={classes.leftSide}>
          <section className={classes.title}>Call the Boys Town National Hotline at 800-448-3000</section>
          <summary className={classes.description}>If you are in a crisis situation and need immediate assistance.</summary>

          <div className={classes.divider}></div>

          <a
            href="https://supremecourt.nebraska.gov/self-help/criminal-record-rehabilitation/juvenile-record-sealing"
            className={classes.link}
            target="_blank"
            rel="noreferrer"
          >
            <section className={classes.title}>File a Motion to Seal Juvenile Criminal Record</section>
          </a>

          <summary className={classes.description}>
            <aside>
              If you have a juvenile record and are wanting to have your records sealed, you can contact Legal Aid of Nebraska or visit the link above
              for more information.
            </aside>
          </summary>

          <div className={classes.divider}></div>

          <a href="https://www.ssa.gov/number-card" className={classes.link} target="_blank" rel="noreferrer">
            <section className={classes.title}>Social Security Number & Card | SSA</section>
          </a>
          <summary className={classes.description}>
            If you are in need of a social security card, this link will help guide you in obtaining a replacement social security card.
          </summary>

          <div className={classes.divider}></div>
        </Grid>

        <Grid item xs={12} lg={6} className={classes.rightSide}>
          <section className={classes.title}>
            Contact the Boys Town National Research Hospital at (531) 355-6589, visit 
            <a href="https://www.boystownhospital.org/medical-records" className={classes.link} target="_blank" rel="noreferrer">
              Medical Records
            </a>
            , or email <a href="mailto:medical.records@boystownhospital.org">medical.records@boystownhospital.org</a>.
          </section>
          <summary className={classes.description}>For questions regarding medical records.</summary>

          <div className={classes.divider}></div>

          <a href="https://www.dmv.org/vital-records/birth-certificates.php" className={classes.link} target="_blank" rel="noreferrer">
            <section className={classes.title}>How to Get a Copy of Your Lost Birth Certificate | DMV.ORG</section>
          </a>

          <summary className={classes.description}>
            If you need a birth certificate, this link will help guide you in obtaining a replacement birth certificate.
          </summary>

          <div className={classes.divider}></div>

          <section className={classes.title}>Call (531) 355-1800</section>
          <summary className={classes.description}>To request Boys Town transcripts or other youth care records.</summary>

          <div className={classes.divider}></div>
        </Grid>
      </Grid>
    </Box>
  );
}
